import type { ZodiacSign } from "@/features/advisors"

import hugeAquarius from "@/assets/img/today/horoscope/signs/signs_huge_aquarius_2x.webp"
import hugeAries from "@/assets/img/today/horoscope/signs/signs_huge_aries_2x.webp"
import hugeCancer from "@/assets/img/today/horoscope/signs/signs_huge_cancer_2x.webp"
import hugeCapricorn from "@/assets/img/today/horoscope/signs/signs_huge_capricorn_2x.webp"
import hugeGemini from "@/assets/img/today/horoscope/signs/signs_huge_gemini_2x.webp"
import hugeLeo from "@/assets/img/today/horoscope/signs/signs_huge_leo_2x.webp"
import hugeLibra from "@/assets/img/today/horoscope/signs/signs_huge_libra_2x.webp"
import hugePisces from "@/assets/img/today/horoscope/signs/signs_huge_pisces_2x.webp"
import hugeSagittarius from "@/assets/img/today/horoscope/signs/signs_huge_sagittarius_2x.webp"
import hugeScorpio from "@/assets/img/today/horoscope/signs/signs_huge_scorpio_2x.webp"
import hugeTaurus from "@/assets/img/today/horoscope/signs/signs_huge_taurus_2x.webp"
import hugeVirgo from "@/assets/img/today/horoscope/signs/signs_huge_virgo_2x.webp"
import smallAquarius from "@/assets/img/today/horoscope/signs/signs_small_aquarius_2x.webp"
import smallAries from "@/assets/img/today/horoscope/signs/signs_small_aries_2x.webp"
import smallCancer from "@/assets/img/today/horoscope/signs/signs_small_cancer_2x.webp"
import smallCapricorn from "@/assets/img/today/horoscope/signs/signs_small_capricorn_2x.webp"
import smallGemini from "@/assets/img/today/horoscope/signs/signs_small_gemini_2x.webp"
import smallLeo from "@/assets/img/today/horoscope/signs/signs_small_leo_2x.webp"
import smallLibra from "@/assets/img/today/horoscope/signs/signs_small_libra_2x.webp"
import smallPisces from "@/assets/img/today/horoscope/signs/signs_small_pisces_2x.webp"
import smallSagittarius from "@/assets/img/today/horoscope/signs/signs_small_sagittarius_2x.webp"
import smallScorpio from "@/assets/img/today/horoscope/signs/signs_small_scorpio_2x.webp"
import smallTaurus from "@/assets/img/today/horoscope/signs/signs_small_taurus_2x.webp"
import smallVirgo from "@/assets/img/today/horoscope/signs/signs_small_virgo_2x.webp"

export interface ZodiacArt {
  huge: string
  small: string
}

export const ZODIAC_ART: Record<ZodiacSign, ZodiacArt> = {
  Aquarius: { huge: hugeAquarius, small: smallAquarius },
  Aries: { huge: hugeAries, small: smallAries },
  Cancer: { huge: hugeCancer, small: smallCancer },
  Capricorn: { huge: hugeCapricorn, small: smallCapricorn },
  Gemini: { huge: hugeGemini, small: smallGemini },
  Leo: { huge: hugeLeo, small: smallLeo },
  Libra: { huge: hugeLibra, small: smallLibra },
  Pisces: { huge: hugePisces, small: smallPisces },
  Sagittarius: { huge: hugeSagittarius, small: smallSagittarius },
  Scorpio: { huge: hugeScorpio, small: smallScorpio },
  Taurus: { huge: hugeTaurus, small: smallTaurus },
  Virgo: { huge: hugeVirgo, small: smallVirgo },
}
